import { ArrowLeftIcon } from 'assets/icons';
import { Breakpoints } from 'common/enums';
import { Spinner } from 'common/spinner';
import { appActions, AppContext } from 'context/app-context';
import { VaultDetailProvider } from 'context/vault-detail-context';
import { vaultSubPageBreadcrumb } from 'helpers/vault-breadcrumbs';
import { useMediaQuery } from 'hooks/use-media-query';
import { VaultsController } from 'networking/controllers/vaults-controller';
import { MoveMemories } from 'pages/vault-detail/components/move-memories';
import { VaultTopBar } from 'pages/vault-detail/components/vault-top-bar';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { goToPage, RouteName } from 'routes';
import styles from './move-memories-page.module.scss';

const MoveMemoriesContent = () => {
  const { id } = useParams<{ id: string }>();
  const vaultId = Number(id);
  const { state: appState, dispatch } = useContext(AppContext);
  const isPhone = useMediaQuery(`(max-width: ${Breakpoints.sm}px)`);

  // The top bar needs the vault (title, albums for the "New" menu). Reuse the
  // one already in context when it's this vault, and fetch it otherwise.
  const [vault, setVault] = useState<VaultType | undefined>(
    appState.currentVault?.id === vaultId ? appState.currentVault : undefined,
  );
  useEffect(() => {
    if (!(vaultId > 0)) return undefined;
    let cancelled = false;
    VaultsController.getVault(vaultId, 'summary')
      .then((fetched) => {
        if (cancelled) return;
        setVault(fetched);
        dispatch({ type: appActions.SET_CURRENT_VAULT, currentVault: fetched });
      })
      .catch(() => {
        if (!cancelled) goToPage(RouteName.NotFoundRedirect);
      });
    return () => {
      cancelled = true;
    };
  }, [vaultId]);

  if (!vault) {
    return (
      <div className={styles.loading}>
        <Spinner />
      </div>
    );
  }

  const breadcrumb = vaultSubPageBreadcrumb(vaultId, 'Move Memories');

  return (
    <div className={styles.page}>
      {/* Phones: the mobile app's screen, with Back above the title. */}
      {isPhone ? (
        <div className={styles.phoneBar}>
          <button
            type="button"
            className={styles.back}
            onClick={breadcrumb[0].onClick}
          >
            <ArrowLeftIcon />
            Back
          </button>
        </div>
      ) : (
        <VaultTopBar vault={vault} breadcrumb={breadcrumb} />
      )}
      <MoveMemories vaultId={vaultId} />
    </div>
  );
};

// The top bar's search / "New" menu need the vault detail context.
export const MoveMemoriesPage = () => (
  <VaultDetailProvider>
    <MoveMemoriesContent />
  </VaultDetailProvider>
);
